import Vue from 'vue'
import { RUN_USER_LOGIN,RUN_USER_LOGOUT,RUN_VERIFY_OTP,RUN_RESEND_OTP,RUN_USER_FORGOT_PASSWORD,RUN_CHANGE_PASSWORD,RUN_STATE_LOAD,GET_TOKEN,SET_STATE,SET_STATE_PERSIST_LOCAL,SET_TOGGLE_LOADER,SET_INFO,GET_USER,RUN_USER_REGISTER,RUN_USER_RESET_PASSWORD_FROM_HASH} from '../types'
import * as types from '@/types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'



export const actions = {
	[RUN_USER_RESET_PASSWORD_FROM_HASH]({commit, state, dispatch,getters}, credentials){
		_executeApi('/change/via/forgot/password', credentials.globalParams , credentials.localParams,'',commit, (error, result)=>{
			if(!error){ 
				credentials.localParams.parameter.response_msg ="Password has been changed successfully. Kindly login again"
				credentials.localParams.parameter.msg_type = 'login--success'
			}else{
				credentials.localParams.parameter.response_msg = result.res_msg
				credentials.localParams.parameter.msg_type = 'login--error'
			}
		})
  	},
  	[RUN_USER_LOGIN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADMIN_LOGIN, credentials.globalParams , credentials.localParams,'',commit, (error, result)=>{
			if(!error){
				result.res_data.user.loggedIn = true
				let role_array = result.res_data.user.roles.split('&')
				result.res_data.user.roles = role_array
				result.res_data.refId = btoa(result.res_data.user.profile.pid)
				
				commit(SET_STATE, result.res_data.user)
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
				credentials.localParams.parameter.$router.replace('/index'); 
				credentials.localParams.parameter.response_msg = "login successfully"
				credentials.localParams.parameter.msg_type = "login-success"
			}else{
				credentials.localParams.parameter.response_msg = result.res_data
				credentials.localParams.parameter.msg_type = 'login-error'
			}
		})
  	},
	[RUN_USER_REGISTER]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_USER_REGISTER, credentials.globalParams, credentials.localParams,'',commit, (error, result)=>{
			if(!error){
				result.res_data.loggedIn = true
				commit(SET_STATE, result.res_data)
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data)))
				
				credentials.localParams.parameter.response_msg = "signup successfully"
				credentials.localParams.parameter.msg_type = "login-success"
				credentials.localParams.parameter.$router.replace('/index')
			}else{
				credentials.localParams.parameter.response_msg = result.res_data
				credentials.localParams.parameter.msg_type = 'login-error'
				//_messageDisplayFunction(credentials.localParams.parameter.$parent,result.res_msg,'error')
			}
		})
	},
	[RUN_USER_LOGOUT]({commit, state, getters}, credentials) {
		credentials.localParams.parameter.pageLoader = true
		RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_ADMIN_LOGOUT,credentials.globalParams, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
		.map(response => response.data)
		.subscribe(data => {
				credentials.localParams.parameter.pageLoader = false
				_handleLogout(data, commit, {router: credentials.localParams.parameter.$router, forward:true})
			},
			(e, d, s) => {
				credentials.localParams.parameter.pageLoader = false
				_handleLogout(e, commit, {router: credentials.localParams.parameter.$router, forward:true})
			}
		)
	},

	[RUN_VERIFY_OTP]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_USER_OTPVERIFY, credentials.globalParams , credentials.localParams,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				let user_json = getters['GET_USER']
				console.log("user_json",user_json)
				user_json.profile.account_verified = 1
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.account_verified = 1						
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				window.gtag('event', 'OTP_verified');
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter,'OTP Add successfully','success')
			}else{
				credentials.localParams.parameter.message = result.res_data.msg
				credentials.localParams.parameter.otpScreen = true
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data.msg,'error')
			}
		})
  	},
	[RUN_RESEND_OTP]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_USER_RESEND_OTP, credentials.globalParams , credentials.localParams,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				_messageDisplayFunction(credentials.localParams.parameter,'OTP resend successfully','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		})
  	},
	
	  //===========================forgot-password=====================================
  	[RUN_USER_FORGOT_PASSWORD]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_USER_FORGOT_PASSWORD, credentials.globalParams , credentials.localParams,'',commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.email = ""
				credentials.localParams.parameter.submitted = false
				_messageDisplayFunction(credentials.localParams.parameter,'A link for change password has been sent on your registered email id','success')
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},

	//=============================change-password=================================== 	
	[RUN_CHANGE_PASSWORD]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials.globalParams , credentials.localParams,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
		  if(!error){
		  		credentials.localParams.parameter.reset()
			  _messageDisplayFunction(credentials.localParams.parameter.$parent,'password changed successfully','success')
		  }else{
			  _messageDisplayFunction(credentials.localParams.parameter.$parent,result.res_data.msg,'error')
		  }
	  }) 

  	},

	[RUN_STATE_LOAD] ({commit, dispatch, state, getters}) {
		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user) 
			user = JSON.parse(user)
		}

		// https://dev.finvasia.com:8083/forgot/password/%242a%2410%24cD1wqfVFu8qaoSK5J1SFs.KObxyTmWKEwpPqyIqA%2FDNfbi0fJ0xei
		if((user == null || user == '' || location.pathname !== '/forgot/password/' || location.pathname !== '/forgot-password') && location.pathname == '/Users/dashboard'){
			window.location.href = "/"
		}
		else{
			commit(SET_STATE, user)
			if(user !== null && user !==''){
				RxFactory.post(Enpoints.BASE_URL + "/get/fresh/user/data", {}  , {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
					.map(response => response.data)
					.subscribe(data => {
						if ('info' in data) {
							if (data.info === 'OK') {
								data.data.user.loggedIn = true
								commit(SET_STATE, data.data.user)
								localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
							}
						}
					},
					e => {					
						_handleErrorResponse(e, commit)
					}
				)
			}
		}
	},
}

//------------------------------------------------functions----------------------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}

function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}

function _handleLogout (data, commit,options,getters) {
	const router = options.router
	let user = {}
	localStorage.removeItem('user');
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.replace("/")
	}
}

function _executeApi (apiLink, globalParams, localParams,getToken,commit, callback) {
	try{
		let response_array = []
		if(getToken == ''){	 getToken = '' }
		localParams.parameter.pageLoader = true
		RxFactory.post(Enpoints.BASE_URL + apiLink, globalParams, getToken)
		.map(response => response.data)
		.subscribe(data => 
		{	localParams.parameter.pageLoader = false
			if ('info' in data){
				if (data.info === 'OK') {
					response_array.res_data = data.data
					callback(false, response_array)
				}
				else{
					response_array.res_data = data.msg
					callback(true, response_array)
				}
			}
		},
		e => {	_handleErrorResponse(e, commit)	}) 
	}catch(ex){	_handleErrorResponse(ex, commit) }
}
function _messageDisplayFunction(getParameter,getMessage,msgType){
	var clss = (msgType == 'success')?'popup--success':'popup--error';
	getParameter.$toasted.show(getMessage, { 
		position: "top-left", 
		duration : 2000,
		containerClass: clss
	});
}




// WEBPACK FOOTER //
// ./src/store/actions.js